module.exports = __webpack_public_path__ + "img/view-product.cf8fcca6.png";